import React, { ReactNode, useEffect, useId } from 'react';
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from '@/components/ui/drawer';
import { ScrollArea } from '@/components/ui/scroll-area';
import { useModalContext } from '@/contexts/ModalProvider';

interface SimpleBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  className?: string;
}

export const SimpleBottomSheet: React.FC<SimpleBottomSheetProps> = ({
  isOpen,
  onClose,
  title,
  children,
  className,
}) => {
  const modalId = useId();
  const { registerModal, unregisterModal } = useModalContext();

  useEffect(() => {
    if (isOpen) {
      registerModal(modalId);
    } else {
      unregisterModal(modalId);
    }
    return () => unregisterModal(modalId);
  }, [isOpen, modalId, registerModal, unregisterModal]);
  return (
    <Drawer open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DrawerContent className={className}>
        {title && (
          <DrawerHeader>
            <DrawerTitle>{title}</DrawerTitle>
          </DrawerHeader>
        )}
        <ScrollArea className="max-h-[80vh] overflow-auto px-4 pb-8">
          {children}
        </ScrollArea>
      </DrawerContent>
    </Drawer>
  );
};

export default SimpleBottomSheet;
